<template>
  <div class="tab-step">
    <div class="step-box">
      <div class="step-item" v-for="(item, index) in list" :key="index" :class="{'active': activeIndex == index}">
        <span>{{index+1}}</span>
        <img v-if="index != (list.length-1)" src="../../assets/images/step-arrow.png">
      </div>
    </div>
    <div class="tips" @click="goJump">{{tipsTitle}}</div>
  </div>
</template>

<script>
export default {
  name: 'Tabstep',
  props: {
    tabList: {
      type: Array,
      default: () => {
        return ['1', '2'];
      }
    },
    activeIndex: {
      type: [String, Number],
      default: 0
    },
    tipsTitle: {
      type: String,
      default: ''
    },
  },
  data() {
    return {
      list: this.tabList
    }
  },
  methods: {
    goJump() {
      if(this.activeIndex != 1) {
        this.$emit('tipsClick');
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.tab-step{
  padding: 0.4rem 0;
  .step-box{
    display: flex;
    justify-content: center;
    align-items: center;
    .step-item{
      display: flex;
      align-items: center;
      justify-content: center;
      &.active span{
        color: #2eaeb4;
        border-color: #2eaeb4;
      }
      span{
        width: 0.48rem;
        height: 0.5rem;
        border-radius: 50%;
        border: 1px solid #666666;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 0.32rem;
        color: #666666;
      }
      img{
        width: 0.9rem;
        height: 0.1rem;
        display: block;
        margin: 0 0.1rem;
      }
    }
  }
  .tips{
    font-size: 0.28rem;
    color: #666666;
    text-align: center;
    margin-top: 0.2rem;
    color: red;
  }
}
</style>